import { getWebViewOwner } from '../getter/getWebViewOwner.util';

interface setRNMessageReceiverParams {
  messageHandler: (e: any) => void;
}

export const setRNMessageReceiver = ({ messageHandler }: setRNMessageReceiverParams) => {
  const receiver = getWebViewOwner() ? window : document;
  receiver.addEventListener('message', (e) => messageHandler(e), { once: true });
};
